import Vapi from '@borisp/vuex-rest-api'
import { payloadToState } from 'utils/helpers'
import { VUE_APP_BASE_API_URL }  from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    settings: {}
  }
})
  .get({
    action: 'getSettings',
    property: 'settings',
    path: '/settings/',
    onSuccess: payloadToState('settings')
  })
  .put({
    action: 'updateSettings',
    property: 'settings',
    path: '/settings/',
    onSuccess: payloadToState('settings')
  })
  .getStore()
